import React from 'react'
import { IonCol, IonGrid, IonImg, IonRouterLink } from '@ionic/react'

export const StoreBadges = () => {
  return (
    <IonGrid className="flex flex-col justify-center items-center">
      <IonCol size="4" className="p-2">
        <IonRouterLink href="https://apps.apple.com/us/app/id1521452228">
          <IonImg src="/assets/images/app-store-badge.png" />
        </IonRouterLink>
      </IonCol>
      <IonCol size="4" className="p-2">
        <IonRouterLink href="https://play.google.com/store/apps/details?id=com.walkingtalking.app">
          <IonImg src="/assets/images/google-play-badge.png" />
        </IonRouterLink>
      </IonCol>
    </IonGrid>
  )
}
